import MessageStatusType from '../../ui/MessageStatus/type';
import * as channelActions from './dux/actionTypes';
import * as topics from '../../lib/pubSub/topics';

export const scrollIntoLast = (selector, intialTry = 0) => {
  const MAX_TRIES = 10;
  const currentTry = intialTry;
  if (currentTry > MAX_TRIES) {
    return;
  }
  try {
    const nodes = document.querySelectorAll(selector);
    const last = nodes[nodes.length - 1];
    last.scrollIntoView(false); /** alignToTop: false */
  } catch (error) {
    setTimeout(() => {
      scrollIntoLast(selector, currentTry + 1);
    }, 500 * currentTry);
  }
};

export const pubSubHandleRemover = (subscriber) => {
  subscriber.forEach((s) => {
    try {
      s.remove();
    } catch {
      //
    }
  });
};

export const pubSubHandler = (channelUrl, pubSub, dispatcher) => {
  const subscriber = new Map();
  if (!pubSub || !pubSub.subscribe) return subscriber;
  subscriber.set(topics.SEND_USER_MESSAGE, pubSub.subscribe(topics.SEND_USER_MESSAGE, (msg) => {
    const { channel, message } = msg;
    scrollIntoLast('.sendbird-msg--scroll-ref');
    if (channel && (channelUrl === channel.url)) {
      dispatcher({
        type: channelActions.SEND_MESSAGEGE_SUCESS,
        payload: message,
      });
    }
  }));
  subscriber.set(topics.SEND_MESSAGE_START, pubSub.subscribe(topics.SEND_MESSAGE_START, (msg) => {
    const { channel, message } = msg;
    if (channel && (channelUrl === channel.url)) {
      dispatcher({
        type: channelActions.SEND_MESSAGEGE_START,
        payload: message,
      });
    }
  }));
  subscriber.set(topics.SEND_FILE_MESSAGE, pubSub.subscribe(topics.SEND_FILE_MESSAGE, (msg) => {
    const { channel, message } = msg;
    scrollIntoLast('.sendbird-msg--scroll-ref');
    if (channel && (channelUrl === channel.url)) {
      dispatcher({
        type: channelActions.SEND_MESSAGEGE_SUCESS,
        payload: message,
      });
    }
  }));
  subscriber.set(topics.UPDATE_USER_MESSAGE, pubSub.subscribe(topics.UPDATE_USER_MESSAGE, (msg) => {
    const { channel, message, fromSelector } = msg;
    if (fromSelector && channel && (channelUrl === channel.url)) {
      dispatcher({
        type: channelActions.ON_MESSAGE_UPDATED,
        payload: message,
      });
    }
  }));
  subscriber.set(topics.DELETE_MESSAGE, pubSub.subscribe(topics.DELETE_MESSAGE, (msg) => {
    const { channel, messageId } = msg;
    if (channel && (channelUrl === channel.url)) {
      dispatcher({
        type: channelActions.ON_MESSAGE_DELETED,
        payload: messageId,
      });
    }
  }));

  return subscriber;
};

export const getParsedStatus = (message, currentGroupChannel) => {
  if (message.requestState === 'failed') {
    return MessageStatusType.FAILED;
  }

  if (message.requestState === 'pending') {
    return MessageStatusType.PENDING;
  }

  if (message.requestState === 'succeeded') {
    if (!currentGroupChannel) {
      return MessageStatusType.SENT;
    }

    const unreadCount = currentGroupChannel.getReadReceipt(message);
    if (unreadCount === 0) {
      return MessageStatusType.READ;
    }

    const isDelivered = currentGroupChannel.getDeliveryReceipt(message) === 0;
    if (isDelivered) {
      return MessageStatusType.DELIVERED;
    }

    return MessageStatusType.SENT;
  }

  return null;
};

export const isOperator = (groupChannel = {}) => {
  const { myRole } = groupChannel;
  return myRole === 'operator';
};

export const isDisabledBecauseFrozen = (groupChannel = {}) => {
  const { isFrozen } = groupChannel;
  return isFrozen && !isOperator(groupChannel);
};

export const getEmojiCategoriesFromEmojiContainer = (emojiContainer = {}) => (
  emojiContainer.emojiCategories ? emojiContainer.emojiCategories : []
);

export const getAllEmojisFromEmojiContainer = (emojiContainer = {}) => {
  const { emojiCategories = [] } = emojiContainer;
  const allEmojis = [];

  for (let categoryIndex = 0; categoryIndex < emojiCategories.length; categoryIndex += 1) {
    const { emojis } = emojiCategories[categoryIndex];
    for (let emojiIndex = 0; emojiIndex < emojis.length; emojiIndex += 1) {
      allEmojis.push(emojis[emojiIndex]);
    }
  }
  return allEmojis;
};

export const getEmojisFromEmojiContainer = (emojiContainer = {}, emojiCategoryId = '') => (
  emojiContainer.emojiCategories
    ? emojiContainer.emojiCategories
      .filter((emojiCategory) => emojiCategory.id === emojiCategoryId)[0].emojis
    : []
);

export const getAllEmojisMapFromEmojiContainer = (emojiContainer = {}) => {
  const { emojiCategories = [] } = emojiContainer;
  const allEmojisMap = new Map();

  for (let categoryIndex = 0; categoryIndex < emojiCategories.length; categoryIndex += 1) {
    const { emojis } = emojiCategories[categoryIndex];
    for (let emojiIndex = 0; emojiIndex < emojis.length; emojiIndex += 1) {
      const { key, url } = emojis[emojiIndex];
      allEmojisMap.set(key, url);
    }
  }
  return allEmojisMap;
};

export const getNicknamesMapFromMembers = (members = []) => {
  const nicknamesMap = new Map();
  for (let memberIndex = 0; memberIndex < members.length; memberIndex += 1) {
    const { userId, nickname } = members[memberIndex];
    nicknamesMap.set(userId, nickname);
  }
  return nicknamesMap;
};

export default getParsedStatus;
